import { initialState } from "./state";

export const setCountries = (state, payload) => {
  state.countries = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
